import { render, staticRenderFns } from "./ECommerceLayout.vue?vue&type=template&id=1a2199f6&"
import script from "./ECommerceLayout.vue?vue&type=script&lang=js&"
export * from "./ECommerceLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports